import { render, staticRenderFns } from "./FinalReview.vue?vue&type=template&id=2d26a97e"
import script from "./FinalReview.vue?vue&type=script&lang=js"
export * from "./FinalReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports